import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { DialogType, Entity } from '@jms/model';
import { Defect, DefectSeverity } from '@jms/model/entities/defect';
import { DeleteFileInfo } from '@jms/ui/ui.attachment';
import { ConfirmService } from '@jms/ui/ui.confirm';
import { FormBuilder } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { SelectButtonModule } from 'primeng/selectbutton';
import { NgIf } from '@angular/common';
import { ContactPickerModule } from '@jms/ui/ui.pickers.contact/contact.picker.module';
import { LuxonCalendarComponent } from '@workbuddy/ui/fields/luxon.calendar/component/luxon.calendar.component';
import { AttachmentModule } from '@jms/ui/ui.attachment/src/attachment.module';
import { DisplayTextPipe } from '@jms/utils/util.pipes';
import { DefectEntityNamePipe } from '../../pipes/defect.entity.name.pipe';

@UntilDestroy()
@Component({
    selector: 'defect-creator',
    templateUrl: './defect.creator.component.html',
    styleUrls: ['./defect.creator.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, CdkTextareaAutosize, SelectButtonModule, NgIf, ContactPickerModule, LuxonCalendarComponent, AttachmentModule, DisplayTextPipe, DefectEntityNamePipe]
})
export class DefectCreatorComponent implements OnChanges {

  @Input() public defect: Defect;
  @Input() public dateFormat: string;
  @Input() public timezone: string;
  @Input() public mode = DialogType;
  @Input() public defaultRaisedBy: Entity;


  public form: UntypedFormGroup;
  public contractor = null;

  public severityOptions = [
    { label: DefectSeverity.Critical, value: DefectSeverity.Critical },
    { label: DefectSeverity.High, value: DefectSeverity.High },
    { label: DefectSeverity.Medium, value: DefectSeverity.Medium },
    { label: DefectSeverity.Low, value: DefectSeverity.Low },
  ];

  public resolveOptions = [
    { label: 'No', value: false },
    { label: 'Yes', value: true }
  ];

  constructor(builder: FormBuilder,
    private confirmService: ConfirmService,
  ) {

    this.form = builder.group({
      _id: [null, []],
      defectNumber: [null, []],
      job: [null, []],
      workOrder: [null, []],
      code: [null, []],
      raisedBy: [null, [Validators.required]],
      raisedAt: [null, [Validators.required]],
      rectifiedBy: [null, [Validators.required]],
      rectifiedAt: [null, [Validators.required]],
      severity: [DefectSeverity.Low, []],
      description: [null, [Validators.required]],
      resolve: [false, []],
      causedBy: [null, [Validators.required]],
      defectEvidence: [[], []],
      rectification: [[], []],
      resolution: [null, []],
      timezone: [null, []]
    });

    this.form.get('resolve').valueChanges
      .pipe(
        untilDestroyed(this),
      )
      .subscribe(resolve => {

        this.form.get('rectifiedBy').enable();
        this.form.get('rectifiedAt').enable();

        if (!resolve) {
          this.form.get('rectifiedBy').disable();
          this.form.get('rectifiedAt').disable();
        }

      });

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.defect) {
      this.form.patchValue(this.defect);
    }

    if (changes?.defaultRaisedBy) {
      this.form.get('raisedBy').setValue(this.defaultRaisedBy);
    }
  }

  public onDeleteAttachment(info: DeleteFileInfo) {
    info.cancel = this.confirmService
      .confirm('Delete Evidence', 'Are you sure wish to delete this file?', 'danger')
      .then(confirm => {

        if (!confirm) {
          return true;
        }


      });
  }

}
